
const styles = (theme) => ({
  customTextField: {
    marginTop: 20,
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px !important',
      fontFamily: theme.typography.fontKanit,
    },
    '& MuiFormControlLabel-label': {
      fontWeight: 400,
      color: '#555'
    },
    '& .MuiOutlinedInput-input': {
      padding: '14px 14px',
  }
    
  },
  textLabel: {
    fontWeight: 400,
    color: '#555'
  },
  label: {
    // Style for the label text
    fontWeight: 400,
    color: '#555',
    fontSize: '1em',
  },
});

export default styles;